<template>
  <v-system-bar class="system-bar"
      style="border-top: 1px solid #e1dfdb; border-bottom: 1px solid #e1dfdb; background-color: #F5F5F5"
      app height="60">
        <img @click="goToHome" height="38px" style="cursor: pointer; float: left; padding-left: 5px; padding-top: 0px;" :src="static_path + '/box21_logo.svg'">
        <span v-if="user_authenticated" class="version" style="color: #46423a; padding-top: 22px; min-width: 110px; padding-left: 10px; float: left; font-size: 0.9em;">
           3.73
        </span>
        <span class="project-description" style="color: #46423a; padding-top: 12px; padding-left: 0px; float: left; font-size: 1.5em;">
             {{selected_project}}
        </span>

        <v-spacer></v-spacer>
          <span v-if="!user_authenticated" class="version" @click="goToLogin" style="cursor: pointer; color: #46423a; padding-top: 4px; min-width: 110px; padding-left: 10px; padding-right: 20px; float: left; font-size: 1.4em;">
            Register
          </span>

          <div
            v-if="user_authenticated && project_id_set && !on_project_page && settings_loaded"
            class="d-flex align-center mr-4"
            style="cursor: pointer"
            data-testid="simple-advanced-toggle"
            @click="onModeToggleClick"
          >
            <v-switch
              :model-value="isAdvancedMode"
              class="mr-1 pointer-events-none"
              density="compact"
              color="primary"
              hide-details
              inset
              readonly
              tabindex="-1"
              :label="$t('simple_mode.advanced_toggle')"
            />
          </div>

          <LocaleSwitcher/>
          <v-btn
                  v-if="user_authenticated && is_global_admin"
                  class="ma-2"
                  text
                  icon
                  @click="goToSuperAdmin"
                  color="blue lighten-2"
                  :aria-label="$t('superadmin_menu.name')"
                  data-testid="superadmin-menu-btn"
          >
            <v-icon>fas fa-shield-alt</v-icon>
          </v-btn>
          <v-btn
                  v-if="user_authenticated"
                  class="ma-2"
                  text
                  icon
                  @click="toggleMessages"
                  color="blue lighten-2"
                  :aria-label="$t('messages.title')"
          >
            <v-badge
                v-if="messages_count > 0"
                color="error"
                :content="messages_count"
                overlap
            >
              <v-icon>fas fa-comment-dots</v-icon>
            </v-badge>
            <v-icon v-else>far fa-comment-dots</v-icon>
          </v-btn>
          <v-btn
                  v-if="user_authenticated"
                  class="ma-2"
                  text
                  icon
                  @click="goToMyProfile"
                  color="blue lighten-2"
          >
              <v-icon v-if="!decoded_avatar_properties">fas fa-user</v-icon>
              <gravatar v-else style="width: 40px;" :selected_properties="decoded_avatar_properties"></gravatar>
          </v-btn>
          <v-btn
            v-if="user_authenticated"
            class="ma-2"
            text
            icon
            @click="goToMyProfile('upgrade-subscription')"
            color="blue lighten-2"
          > 
              <v-icon v-if="subscriptionIcon" large color="primary">{{ subscriptionIcon }}</v-icon>
          </v-btn>

          <v-btn
              v-if="user_authenticated"
            class="ma-2"
            text
            icon
            @click="sign_out"
            color="blue lighten-2"
          >
            <v-icon>fas fa-sign-out-alt</v-icon>
          </v-btn>

          <v-btn
              v-else
              :class="['ma-2', { 'frontpage-login-btn': isFrontPage }]"
              :variant="isFrontPage ? 'flat' : 'text'"
              icon
              @click="goToLogin"
              :color="isFrontPage ? undefined : 'black'"
              :aria-label="$t('login.tab_login')"
          >
            <v-icon :color="isFrontPage ? 'white' : undefined">fas fa-sign-in-alt</v-icon>
          </v-btn>
    </v-system-bar>
</template>

<script>
import LoadProjectsMixin from "@/mixins/LoadProjectsMixin";
import CurrentUserMixin from "@/mixins/CurrentUserMixin";
import LoadSettingsMixin from "@/mixins/LoadSettingsMixin";
import Gravatar from "@/components/users/Gravatar";
import SnackbarsMixin from "@/mixins/SnackbarsMixin.vue";
import LocaleSwitcher from "@/components/LocaleSwitcher";
import { onProjectsPage } from '@/util/routesHelper.js';


export default {
  mixins: [LoadProjectsMixin, CurrentUserMixin, SnackbarsMixin, LoadSettingsMixin],
  name: "MenuBar",
  components: { Gravatar, LocaleSwitcher },
  data() {
    return {
    };
  },
  methods: {
    sign_out() {
      this.$api.clear_session();
      this.$store.commit("user/clear_users");
      this.$store.commit("user/set_current_project_id", false);
      this.$store.commit("messages/reset");
      if (this.$route.path !== '/login') {
        this.$router.push("/login");
      }
    },
    toggleMessages() {
      this.$store.dispatch("messages/toggle_panel");
    },
    fetchMessages(autoOpen = false) {
      if (!this.user_authenticated) {
        return;
      }
      this.$store.dispatch("messages/fetch_inbox", { auto_open: autoOpen });
    },
    goToMyProfile(source) {
      if (source === 'upgrade-subscription') {
        if (this.$route.path !== '/profile/upgrade-subscription') {
          this.$router.push({ path: '/profile/upgrade-subscription' });
        }
      } else {
        if (this.$route.path !== '/myprofile') {
          this.$router.push("/myprofile");
        }
      }
    },
    goToSuperAdmin() {
      if (this.$route.path !== '/superadmin') {
        this.$router.push('/superadmin');
      }
    },
    goToLogin() {
      if (this.$route.path !== '/login') {
        this.$router.push("/login");
      }
    },
    goToHome() {
      if (this.user_authenticated) {
        if (this.$route.path !== '/projects') {
          this.$router.push("/projects");
        }
      }
      else {
        this.$router.push("/");
      }
    },
    async onModeToggleClick() {
      // Prefer route so a stale settings cache cannot invert the toggle.
      const wantAdvanced = this.$route.name === 'SimpleMode' || this.simple_mode;
      await this.onAdvancedToggle(wantAdvanced);
    },
    async onAdvancedToggle(wantAdvanced) {
      const enabledSimple = !wantAdvanced;
      const projectId = this.$store.getters['user/get_current_project_id'];
      if (projectId && projectId !== 'false') {
        sessionStorage.setItem('project_id', String(projectId));
      }
      try {
        await this.$api.setting.patch({
          name: 'simple_mode',
          value: enabledSimple ? 'true' : 'false',
        });
        await this.$store.dispatch('setting/all', { force_reload: true });
        if (wantAdvanced) {
          if (this.$route.name !== 'ProjectOverview') {
            await this.$router.push({ name: 'ProjectOverview' });
          }
        } else if (this.$route.name !== 'SimpleMode') {
          await this.$router.push({ name: 'SimpleMode' });
        }
      } catch (e) {
        this.$store.dispatch(
          'snackbars/add_failed_snack',
          this.$t('simple_mode.mode_switch_failed') || 'Could not switch mode',
        );
      }
    },
    async applyAdvancedMode(wantAdvanced) {
      await this.onAdvancedToggle(Boolean(wantAdvanced));
    },
  },
  mounted() {
    this.fetchMessages(true);
  },
  watch: {
    user_authenticated(isAuth) {
      if (isAuth) {
        this.fetchMessages(true);
      }
    },
    current_project_id() {
      this.fetchMessages(false);
      this.load_settings({ force_reload: true });
    },
  },
  computed: {
    isAdvancedMode() {
      if (this.$route.name === 'SimpleMode') {
        return false;
      }
      return !this.simple_mode;
    },
    project_id_set() {
      const project_id = this.$store.getters['user/get_current_project_id'];
      return project_id && project_id !== 'false' && project_id !== false;
    },
    on_project_page() {
      return onProjectsPage.call(this);
    },
    messages_count() {
      return this.$store.getters['messages/get_total_count'];
    },
    current_project_id() {
      return this.$store.getters['user/get_current_project_id'];
    },
    subscriptionIcon() {
      if (this.on_unauthenticated_pages) {
        return;
      }
      if (this.user_sub_id === null) {
        return "fas fa-spinner fa-spin";
      }

      const subscriptionId = Number(this.user_sub_id);

      switch (subscriptionId) {
        case 0:
          return "fas fa-seedling";
        case 1:
          return "fas fa-tree";
        case 2:
          return "fa-solid fa-mountain";
        case 3:
          return "fa-solid fa-earth-europe";
        default:
          return "fas fa-seedling";
      }
    },
    decoded_avatar_properties() {
      return this.current_user ? this.current_user.avatar_properties : null;
    },
    user_authenticated() {
      return this.current_user !== false;
    },
    static_path() {
      return this.$api_url;
    },
    isFrontPage() {
      return this.$route.name === 'FrontPage';
    },
    selected_project() {
      let project_id = this.$store.getters["user/get_current_project_id"];
      let selected = this.projects.filter((project) => {
        return project.id === parseInt(project_id);
      });

      if (selected.length === 0) {
        return "";
      } else {
        return selected[0].name;
      }
    },
  },
};
</script>

<style scoped>
/* Matches /api/static/frontpage/keypoints.svg fill (#79ADD5) */
.frontpage-login-btn {
  background-color: #79ADD5 !important;
  color: #FFFFFF !important;
}

.frontpage-login-btn:hover {
  background-color: #6a9dc4 !important;
}

@media (max-width: 600px) {
  img {
    height: 30px;
  }

  .version {
    display: none;
  }

  .project-description {
    display: none; 
  }
}
</style>